<div class='full-page'>
  <app-header *ngIf="isLoggedIn"></app-header>
  <app-sp-sidenav *ngIf="isLoggedIn"></app-sp-sidenav>
  <div class="menus" *ngIf="isLoggedIn">
    <div class="hide-in-large">
      <nav aria-label="mobile-navbar" [ngClass]="{'navbar navbar-expand-md':true,'hide-menu': router.url == '/telemetry'}">

        <ul class="navbar-nav nav-tabs">
          <li [ngClass]="{'cursorPointerHand':true,'nav-item active':true,'responsive-active-link':router.url == '/dashboard'}">
            <a class="nav-link" [ngStyle]="{'border-bottom':(router.url == '/dashboard' || router.url =='/') ? '4px solid white': ''}"
               routerLink='/dashboard' (click)="DashboardNav($event)" translate>
              <p class=" iconFntPosMobile">
                <img src="assets/dashboard.svg" class="icon-action" height="29" width="29" alt="dashboard"/>
              </p>
              <p class="menu-name"> {{labels.menuDashboard | translate}}</p>
            </a>
          </li>
          <li [ngClass]="{'cursorPointerHand':true,'nav-item active':true,'responsive-active-link':router.url.includes('alarms')}">
            <a class="nav-link" [ngStyle]="{'border-bottom':router.url.includes('alarms') ? '4px solid white': ''}" routerLink='/alarms'
               translate>
              <p class=" iconFntPosMobile">
                <img src="assets/alarm-clock.svg" class="icon-action alarm-clock" height="21" width="21" alt="clock"/>
              </p>
              <p class="menu-name"> {{labels.menuAlarms|translate}}</p>
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="hide-in-mobile">
      <nav aria-label="navbar" class="navbar navbar-expand-sm bg-success navbar-dark">
        <ul class="navbar-nav nav-tabs">
          <li class="nav-item active cursorPointerHand">
            <a class="nav-link" [ngStyle]="{'border-bottom':router.url == '/dashboard' ? '4px solid white': ''}" routerLink='/dashboard' (click)="clearAllMenu($event)" translate>{{labels.menuDashboard}}</a>
          </li>
          <li class="nav-item active cursorPointerHand">
            <a class="nav-link" [ngStyle]="{'border-bottom':router.url == '/statistics'?'4px solid white':''}" routerLink='/statistics' (click)="clearAllMenu($event)" translate>{{labels.menuStatistics}}</a>
          </li>
          <li class="nav-item active cursorPointerHand">
            <a class="nav-link" [ngStyle]="{'border-bottom': router.url == '/rules' || router.url == '/alarms' ? '4px solid white':''}" routerLink='/alarms' (click)="AlarmNav($event)" translate>
              {{labels.alarms}}
            </a>
          </li>
          <li class="nav-item active cursorPointerHand">
            <a class="nav-link" [ngStyle]="{'border-bottom':router.url == '/device' || router.url == '/users' || router.url == '/drivermanager' || router.url == '/oem' || router.url=='/device-metadata' ? '4px solid white':''}" routerLink="{{mgmtLink}}" (click)="MgmtNav($event)"
               translate>
              {{labels.menuManagement}}
            </a>
          </li>
          <li class="nav-item active cursorPointerHand">
            <a class="nav-link" [ngStyle]="{'border-bottom':router.url == '/devicegroups' ? '4px solid white':''}" (click)="GrpNav($event)" routerLink='/devicegroups'
               translate>
              {{labels.menuGroup}}
            </a>
          </li>
          <li class="nav-item active cursorPointerHand">
            <a class="nav-link" [ngStyle]="{'border-bottom':router.url == '/haccpreports' || router.url=='/export' ? '4px solid white':''}" (click)="DataExpt($event)" routerLink='/haccpreports'
               translate>
              {{labels.menuDataExport}}
            </a>
          </li>


      </ul>
      </nav>
      <div *ngIf="isAlarmSubMenu==true" class="width100per height2rem">
        <!--Details Sub Menu-->
        <nav aria-label="subNavbar" class="navbar navbar-expand-sm main-sub-menu" role="sub">
          <ul class="navbar-nav nav-tabs">
            <!--Alarm Information-->
            <li class="nav-item-sub active">
              <a [ngStyle]="{'border-bottom':router.url.includes('alarms') ?'2px solid #3DCD58':'','color':router.url.includes('alarms') ?'#3DCD58':''}" routerLink='/alarms' translate>{{labels.menuAlarms}}</a>
            </li>
            <!--Rule Information-->
            <li class="nav-item-sub active">
              <a [ngStyle]="{'border-bottom':router.url == '/rules' ?'2px solid #3DCD58':'','color':router.url == '/rules' ?'#3DCD58':''}" routerLink='/rules' translate>{{labels.menuRules}}</a>
            </li>
          </ul>
        </nav>
      </div>
      <div *ngIf="isMgmtSubMenu==true" class="width100per height2rem">

        <nav aria-label="subNavbar-expand" class="navbar navbar-expand-sm main-sub-menu" role="sub">
          <ul class="navbar-nav nav-tabs">
            <!--User Information-->
            <li class="nav-item-sub active" *ngIf="(roleCd==roles.master || roleCd==roles.enduser || roleCd==roles.cuserW)">
              <a [ngStyle]="{'border-bottom':router.url == '/users' ? '2px solid #3DCD58':'','color':router.url == '/users' ?'#3DCD58':''}" routerLink='/users' translate>{{labels.menuUsers}}</a>
            </li>
            <li *ngIf="roleCd==roles.master" class="nav-item-sub active">
              <a [ngStyle]="{'border-bottom':router.url == '/oem' ?'2px solid #3DCD58':'','color':router.url == '/oem' ?'#3DCD58':''}" routerLink='/oem' translate>
                {{labels.oem}}
              </a>
            </li>
            <!--Devics Information-->
            <li class="nav-item-sub active">
              <a [ngStyle]="{'border-bottom':router.url == '/device' ? '2px solid #3DCD58':'','color':router.url == '/device' ?'#3DCD58':''}" routerLink='/device' translate>{{labels.menuDevice}}</a>
            </li>
            <!--Driver Manager-->
            <li class="nav-item-sub active" *ngIf="roleCd == roles.master">
              <a [ngStyle]="{'border-bottom':router.url == '/drivermanager' ?'2px solid #3DCD58':'','color':router.url == '/drivermanager' ?'#3DCD58':''}" routerLink='/drivermanager' translate>
                {{labels.driverManager}}
              </a>
            </li>
            <li class="nav-item-sub active" *ngIf="roleCd == roles.master">
              <a [ngStyle]="{'border-bottom':router.url == '/device-metadata' ?'2px solid #3DCD58':'','color':router.url == '/device-metadata' ?'#3DCD58':''}" routerLink='/device-metadata' translate>
                {{labels.deviceMetadata}}
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div *ngIf="isGrpSubMenu==true" class="width100per height2rem">
        <!--Details Sub Menu-->
        <nav aria-label="Navbar-expand" class="navbar navbar-expand-sm main-sub-menu" role="sub">
          <ul class="navbar-nav nav-tabs">
            <!--Device Groups-->
            <li class="nav-item-sub active">
              <a [ngStyle]="{'border-bottom':router.url == '/devicegroups' ? '2px solid #3DCD58':'','color':router.url == '/devicegroups' ?'#3DCD58':''}" routerLink='/devicegroups' translate>
                {{labels.menuManageDeviceGroups}}
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div *ngIf="isDataExprtSubMenu==true" class="width100per height2rem">
        <!--Details Sub Menu-->
        <nav aria-label="main-sub-menu" class="navbar navbar-expand-sm main-sub-menu" role="sub">
          <ul class="navbar-nav nav-tabs">
            <!--Haccp Report-->
            <li class="nav-item-sub active">
              <a [ngStyle]="{'border-bottom':router.url == '/haccpreports' ?'2px solid #3DCD58':'','color':router.url == '/haccpreports' ?'#3DCD58':''}" routerLink='/haccpreports' translate>{{labels.menuHACCPReport}}</a>
            </li>
            <!--Export-->
            <li *ngIf="(roleCd==roles.master || roleCd==roles.enduser || roleCd==roles.oemuser)" class="nav-item-sub active">
              <a [ngStyle]="{'border-bottom':router.url == '/export' ? '2px solid #3DCD58':'','color':router.url == '/export' ?'#3DCD58':''}" routerLink='/export' translate>{{labels.menuExport}}</a>
            </li>
          </ul>
        </nav>
      </div>

    </div>
  </div>
  <div *ngIf="isLoggedIn">
    <div *ngIf="showBroadcastMessagebanner" class="broadcastMessageContent">
      <img class="close" src="assets/close.svg" alt="close" height="29" width="29" (click)="closeBroadcastmessage()" (keydown)="closeBroadcastmessage()" (keypress)="closeBroadcastmessage()"  (keyup)="closeBroadcastmessage()"/>
      <span class="message">
        {{broadcastMessage}}

        <span *ngIf="showMore" class="show-more-link" (click)="showMoreMessage()" (keydown)="showMoreMessage()" (keypress)="showMoreMessage()" (keyup)="showMoreMessage()">{{labels.showMore}}</span>

      </span>
    </div>
  </div>
  <div class="page-container mb-4" >
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="isLoggedIn"></app-footer>
</div>
<div class="se-dialog" *ngIf="showMoreDialog">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{ labels.broadcastMessage }}</h3>
    </div>
    <div class="se-dialog-body se-dialog-body-message">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      {{ broadcastMessagelong | translate }}
    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="closeShowMore()">{{ labels.close | translate}}</button>
    </div>
  </div>
</div>
